import api from '@/api/index.js'

const distributor_report = {
  state: {
    fileLoading: false,
    loading: false,
    reportData: null,
    error: null
  },


  mutations: {
    DISTRIBUTOR_REPORT_LOADING: (state, loading) => {
      state.loading = loading;
    },
    DISTRIBUTOR_OPERATIONS_REPORT_FILE_LOADING: (state, loading) => {
      state.fileLoading = loading;
    },
    DISTRIBUTOR_REPORT: (state, response) => {
      state.reportData = response;
      state.loading = false;
    },
    DISTRIBUTOR_REPORT_ERROR: (state, error) => {
      state.error = error;
    }
  },

  actions: {
    GetDistributorReport({commit}, query) {
      let reqQueryStr = '';
      if (query.period.year) {
        reqQueryStr = `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr = `from=${query.period.from}&to=${query.period.to}`
      }

      commit('DISTRIBUTOR_REPORT_ERROR', null)
      commit('DISTRIBUTOR_REPORT', null)
      commit('DISTRIBUTOR_REPORT_LOADING', true)
      return api.get(`reports/distributors/${query.distributorId}?` + reqQueryStr)
        .then((response) => {
          commit('DISTRIBUTOR_REPORT', response)
        })
        .catch((error) => {
          commit('DISTRIBUTOR_REPORT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('DISTRIBUTOR_REPORT_LOADING', false)
        })
    },
    GetDistributorOperationsReportFile({commit}, query) {
      let reqQueryStr = '';
      if (query.period.year) {
        reqQueryStr = `year=${query.period.year}&month=${query.period.month}`
      } else {
        reqQueryStr = `from=${query.period.from}&to=${query.period.to}`
      }

      commit('SET_ERROR', null)
      commit('DISTRIBUTOR_OPERATIONS_REPORT_FILE_LOADING', true)
      return api.file(`reports/distributors/${query.distributorId}/operations?` + reqQueryStr)
        .then((response) => {
          let fileName = response.headers.get('content-disposition').split("filename=")[1].replaceAll('"', '');
          if (fileName == "") {
            fileName = "result.csv"
          }
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName;
          link.click()
          commit('DISTRIBUTOR_OPERATIONS_REPORT_FILE_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('DISTRIBUTOR_OPERATIONS_REPORT_FILE_LOADING', false)
        })
    },
  },
}

export default distributor_report
